export default {
  LIST(state, data) {
    state.monitorings = data
  },
  GET(state, data) {
    state.monitoring = data
  },
  UPDATE(state, value) {
    state.monitoring = {
      ...value,
    }
  },
  FRESH(state) {
    state.monitoring = {
      id: null,
      name: '',
      work_type: '',
      period: null,
      quarter: null,
      file: null,
    }
  },
}
